export default "__VITE_ASSET__6dfd8556__"